import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #ffffff;
    width: 100%;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-optical-sizing: auto;
    font-weight: 300;
    letter-spacing: 1px;
    font-style: normal;
    font-size: 18px;
  }
  
  
  * {
    box-sizing: border-box;
  }
`;

export default GlobalStyle;
